




































































import { defineComponent, useContext } from '@nuxtjs/composition-api'
import QuantitySelector from '../ProductPage/PurchaseOptions/QuantitySelector.vue';
import { cartProductQuantityLink } from '~/helpers/trackings/24orepro/cart';

export default defineComponent({
    props:{
        item:{
            required: true,
            type: Object //@TODO define type
        },
        updateQty:{
            type: Function,
            required: true
        },
        isFullCart:{
            type:Boolean,
            default: false
        },
        removeFn:{
            type: Function,
            default:()=>{console.log('default remove fn')}
        }
    },
    components:{
        QuantitySelector
    },
    data(){
        return{
            sprite: require('~/assets/solepro/spritemap.svg'),
        }
    },
    computed: {
        isDigital(): boolean {
            const item = this.$props.item as any;
            
            if (!item || !item.secondLine || !Array.isArray(item.secondLine)) {
                return false;
            }
            
            const formatoLine = item.secondLine.find((line: any) => 
                line && typeof line === 'object' && line.title === 'Formato'
            );
            
            if (!formatoLine || !formatoLine.content || typeof formatoLine.content !== 'string') {
                return false;
            }
            
            return formatoLine.content.toLowerCase().includes('digitale');
        }
    },
    setup(){
        const { app } = useContext();
        return {
            IMAGE_STATIC_REPLACEMENT: app.$config.IMAGE_STATIC_REPLACEMENT,
            IMAGE_CDN_REPLACEMENT: app.$config.IMAGE_CDN_REPLACEMENT,
        }
    },
    methods: {
        trackQuantityEvent(label) {
            cartProductQuantityLink(this.item, label)
        }
    }
})
